import React from "react";

export default React.createContext(null);

export const Actions = {
    TO_STAGE: "TO_STAGE",
    PREV_STAGE: "PREV_STAGE",
    SELECTED_TEAM_ADMIN: "SELECTED_TEAM_ADMIN",
    SELECTED_TEAM_MEMBER: "SELECTED_TEAM_MEMBER",
    SELECTED_EMAIL_SIGNUP: "SELECTED_EMAIL_SIGNUP",
    SEARCHED_FOR_TEAM_NAME: "SEARCHED_FOR_TEAM_NAME",
    SEARCHED_FOR_LOCATION_NAME: "SEARCHED_FOR_LOCATION_NAME",
    REQUESTED_USER_DETAILS: "REQUESTED_USER_DETAILS",
    RECEIVED_STORED_USER_DETAILS: "RECEIVED_STORED_USER_DETAILS",
    UPDATED_USER_DETAILS: "UPDATED_USER_DETAILS",
    SELECTED_LOCATION: "SELECTED_LOCATION",
    SELECTED_TEAM_NOT_LISTED: "SELECTED_TEAM_NOT_LISTED",
    SELECTED_TEAM: "SELECTED_TEAM",
    ADDED_TEAM: "ADDED_TEAM",
    COMPLETED_SIGNUP: "COMPLETED_SIGNUP",
    CANCELLED_SIGNUP: "CANCELLED_SIGNUP",
    USER_ALREADY_LOGGED_IN: "USER_ALREADY_LOGGED_IN",
    SELECTED_LOGGED_IN_TEAM: "SELECTED_LOGGED_IN_TEAM",
    USER_ENTERED_EMAIL: "USER_ENTERED_EMAIL",
    RECEIVED_USER_TEAMS_DATA: "RECEIVED_USER_TEAMS_DATA",
    RECEIVED_SESSION_DATA: "RECEIVED_SESSION_DATA",
    RECEIVED_LINK_ACCOUNTS_REQUEST: "RECEIVED_LINK_ACCOUNTS_REQUEST",
    RECEIVED_USER_NOT_FOUND_RESPONSE: "RECEIVED_USER_NOT_FOUND_RESPONSE",
    CANCELLED_LOGIN: "CANCELLED_LOGIN",
    SELECTED_FORGOT_PASSWORD: "SELECTED_FORGOT_PASSWORD",
};
